import { LearningMenuType } from "@/components/Learning/LearningMiddle/config/LearningMenuType";
import type { LearningStoreActions } from "@/store/learning/actions";
import type { LearningStoreState } from "@/store/learning/state";
import { createDirectoryState } from "@/store/learning/state/factories";
import { useLearningAssessmentStore } from "@/store/learning/assessment/learningAssessmentStore";
import { LearningCourseModel } from "~~/package/mapper/learning/model/LearningCourseModel";
import { TaskModel } from "~~/package/mapper/learning/model/TaskModel";

export const resetActions = {
    resetMultiFileLearning(): void {
        (this as LearningStoreState).directory = createDirectoryState();
        (this as LearningStoreState).frontLearning.defaultLocation = "";
        (this as LearningStoreState).frontLearning.currentLocation = "";
    },
    resetAssessment(): void {
        (this as LearningStoreState).task = new TaskModel();
        useLearningAssessmentStore().resetAssessment();
        (this as LearningStoreActions).clearCustomFunctions();
    },
    resetProSkillAssure(): void {
        useLearningAssessmentStore().resetProSkillAssure();
        (this as LearningStoreState).unsubmittedChangeByTaskId = {};
    },
    resetAll(): void {
        (this as LearningStoreState).task = new TaskModel();
        (this as LearningStoreState).course = new LearningCourseModel();
        (this as LearningStoreState).menuType = LearningMenuType.None;
        (this as LearningStoreState).menuActiveList = [];

        (this as LearningStoreActions).resetCodeData();
        (this as LearningStoreActions).resetAssessment();
        (this as LearningStoreActions).resetProSkillAssure();
        (this as LearningStoreActions).resetLearningMessage();
        (this as LearningStoreActions).resetInitData();
    },
    resetContestData(): void {
        useLearningAssessmentStore().resetContestData();
        (this as LearningStoreActions).clearCustomFunctions();
    },
    resetLevelAssessment(): void {
        useLearningAssessmentStore().resetLevelAssessment();
    }
};
